//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    article: { type: Object, default: null },
    titleTag: { default: 'h4' },
  },
}
